<template>

    <div style="max-width: 400px;">

        <a v-bind:href="file.url" target="_blank">
            <p v-if="file.url">{{ getNameFromUrl(file.url) }}</p>
        </a>

        <input type="hidden"
               :name="inputName"
               v-if="file.url"
               v-model="file">

        <div>
            <a href="javascript:void(0)" class="btn btn-sm btn-primary" @click="showFileManager()">
                <span v-if="file.url === null">{{ t.__('Wybierz') }}</span>
                <span v-if="file.url !== null">{{ t.__('Zmień') }}</span>
            </a>
            <a href="javascript:void(0)" class="btn btn-sm btn-danger" v-if="file.url !== null" @click="clear()">{{ t.__('Usuń') }}</a>
        </div>

    </div>

</template>

<script>
    import File from "./classes/File";

    export default {
        props: {
            inputName: {
                type: String,
                default: null
            },
            value: {
                type: File,
                default: null
            },
            mimeTypes: {
                type: String,
                default: null
            },
        },
        data() {
            return {
                eventHub: window.eventHub,
                file: this.value
            }
        },
        model: {
            event: 'change'
        },
        methods: {
            showFileManager() {
                this.eventHub.$emit('show-file-manager', this._uid, 'file', this.mimeTypes)
            },
            clear() {
                this.file.reset();
                this.$emit('change', this.image);
            },
            getNameFromUrl(url) {
                return url.substring(url.lastIndexOf('/')+1);
            }
        },
        beforeMount() {
            if (this.file == null) {
                this.file = new File();
            }
        },
        mounted() {
            this.eventHub.$on('file-manager-selected-' + this._uid, (file) => {
                this.file.selectFromLibrary(file);
                this.$emit('change', this.file);
                this.eventHub.$emit('hide-file-manager');
            });
        }
    };
</script>
